import { Component } from '@angular/core';

@Component({
  selector: 'app-after-login',
  standalone: true,
  imports: [],
  templateUrl: './after-login.component.html'
})
export class AfterLoginComponent {}
